// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function template_list_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var template_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "template_title"), null));
  if (template_title.TAG === /* Ok */0) {
    var template_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "template_id"), null));
    if (template_id.TAG === /* Ok */0) {
      var template_message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "template_message"), null));
      if (template_message.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  template_title: template_title._0,
                  template_id: template_id._0,
                  template_message: template_message._0
                }
              };
      }
      var e = template_message._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".template_message" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = template_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".template_id" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = template_title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".template_title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var templates = Decco.listFromJson(template_list_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "templates"), null));
  if (templates.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              templates: templates._0
            }
          };
  }
  var e = templates._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".templates" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  template_list_decode ,
  t_decode ,
  
}
/* No side effect */
